exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-field{position:relative}.date-field img{position:absolute;right:0;padding:11px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:10}.date-field .note-calendar{font-size:14px;color:#ff3b30}.date-field .datepicker{width:100%}.date-field .datepicker input{height:46px;background-color:#f2f2f2;outline:none;border:none;font-size:14px;padding:12px 0 0 12px;border-top-right-radius:4px!important;border-bottom-right-radius:4px!important}.date-field .label--date_field{position:absolute;font-size:10px;color:#7a8189;padding:3px 12px;z-index:5}", ""]);

// exports
